import React from 'react'
import { Typography, SwxTheme, Box } from 'swx-atomic-component-lib'
import i18n from '../../i18n'
import styles from './styles'

function goBack () {
  window.history.back()
}

const AppDown = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const name = urlParams.get('name')

  return (
    <Box customStyle={styles.container(SwxTheme)}>
      <Box customStyle={styles.subContainer}>
        <Box customStyle={styles.logo}>
          <img src='symbol-white.svg' alt='SmarterWX Logo' />
          <Typography size='32px' color='white'>{i18n.appDownPage.title}</Typography>
        </Box>
        <Box>
          <Typography customStyle={styles.statusTitle(SwxTheme)}>
            {i18n.appDownPage.statusTitle}
          </Typography>

          <Typography customStyle={styles.description(SwxTheme)}>
            {i18n.formatString(i18n.appDownPage.description, { name })}<br />{i18n.appDownPage.checkBack}
          </Typography>

          <Typography customStyle={styles.link(SwxTheme)} onClick={goBack}>
            {i18n.appDownPage.link}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default AppDown
